module.exports = __webpack_public_path__ + "img/drifter-zone-wechat-mobile.87fa1aa.png";